import { useState } from 'react';
import { Brand, brandLogo } from '../lib/brandLogos';

/** Logo de uma marca (logo.dev ou ícone local). Se a imagem falhar, some sem quebrar o layout. */
export function BrandLogo({ brand, size = 24, rounded = 6, title }: { brand: Brand; size?: number; rounded?: number; title?: string }) {
  const [failed, setFailed] = useState(false);
  const { src, label } = brandLogo(brand, Math.max(32, size * 2));
  if (failed) return null;
  return (
    <img
      src={src}
      alt={title ?? label}
      title={title ?? label}
      width={size}
      height={size}
      loading="lazy"
      onError={() => setFailed(true)}
      style={{ width: size, height: size, borderRadius: rounded, objectFit: 'contain', flexShrink: 0 }}
    />
  );
}
